import { render } from "./MobCategoryViewKollection.vue?vue&type=template&id=fca9d232&scoped=true"
import script from "./MobCategoryViewKollection.vue?vue&type=script&lang=js"
export * from "./MobCategoryViewKollection.vue?vue&type=script&lang=js"

import "./MobCategoryViewKollection.vue?vue&type=style&index=0&id=fca9d232&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca9d232"]])

export default __exports__